"use client";

import { type ReactElement } from "react";
import { type Organization } from "../../lib/types";

interface FooterOrganizationProps extends React.ComponentProps<"li"> {
  organization: Organization;
}

function FooterOrganization({
  organization,
}: Readonly<FooterOrganizationProps>): ReactElement | null {
  if (organization.url)
    return (
      <a href={organization.url} target="_blank" rel="nofollow">
        <img
          className="w-auto max-h-16"
          src={organization.picture}
          alt={organization.name}
          width={organization.size?.width}
          height={organization.size?.height}
          sizes="96px"
        />
      </a>
    );

  return (
    <img
      className="w-auto max-h-16"
      src={organization.picture}
      alt={organization.name}
      width={organization.size?.width}
      height={organization.size?.height}
      sizes="96px"
    />
  );
}

export { FooterOrganization, type FooterOrganizationProps };
